import React from 'react'
import Layout from '../../Layout'
import NotPaidOrderContainer from '../../../../Components/OrdersPart/NotPaidOrderContainer/NotPaidOrderContainer';

const AcceptedOrderSupplier = () => {
  return (
    <Layout>
      <NotPaidOrderContainer/>
    </Layout>
  )
}

export default AcceptedOrderSupplier